import Vue from 'vue'
import Vuex from 'vuex'
import apiClient from '@/services/axios'
import router from '@/router'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    sessionId: null,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async SIGNIN({ commit }, { email, password }) {
      try {
        const outerData = await apiClient.post('/account/login', {
          email,
          password,
        })

        // console.log(outerData)

        const { data } = outerData
        // console.log(data.user)

        // console.log(data)
        // console.log(new Date(expireDate))
        // console.log(this.$cookies)
        // this.$cookies.set('sessionId', data.token, properExpireDate, '/')
        // console.log(this.$cookies.get('sessionId'))
        return new Promise((resolve, reject) => {
          resolve({ user: data.user, session: data.sessionId })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async REGISTER_ACCOUNT({ commit }, { registerData }) {
      try {
        // console.log(registerData)
        const { data } = await apiClient.post(
          '/account/register',
          registerData,
        )

        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async LOGOUT({ commit }, _) {
      // await apiClient.post()
      await apiClient.post('/account/logout')
      Vue.$cookies.remove('sessionId')
      Vue.$cookies.remove('user')
      localStorage.clear()
      commit('SET_STATE', { sessionId: null })
      router.push({ name: 'Masuk' })
    },
    async FETCH_USER_DATA({ commit }) {
      try {
        const { data } = await apiClient.get('/user/by-id')
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async GOOGLE_SIGN_IN(_, { idToken }) {
      try {
        const { data: { message, user: data, googleIdToken } } = await apiClient.get('/account/google-sign-in', { params: { idToken } })
        return new Promise((resolve, reject) => {
          resolve({ message, data, googleIdToken })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async UPDATE_USER_PROFILE({ commit }, { newUserProfile }) {
      try {
        await apiClient.put('/user/edit-profile', newUserProfile)
        return new Promise((resolve, reject) => {
          resolve({ isSuccess: true })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async UPDATE_USER_ACCOUNT({ commit }, { payload }) {
      let isSuccess = false
      try {
        const { data } = await apiClient.put('/user/setting-account', payload)
        isSuccess = true
        return new Promise((resolve, reject) => {
          resolve({ isSuccess, data })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async USER_FIND_BY(_, { findBy, data }) {
      try {
        const {
          data: { message, user },
        } = await apiClient.post('/account/find', { findBy, data })
        return new Promise((resolve, reject) => {
          resolve({ message, user })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async SEND_HELP(_, payload) {
      try {
        await apiClient.post('/account/send-help', payload)
        return new Promise((resolve, reject) => {
          resolve()
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async GENERATE_LINK_FORGOT_PASSWORD({ commit }, email) {
      let status = false
      try {
        const { data } = await apiClient.post('/account/forgot-password', email)
        status = true
        return new Promise((resolve, reject) => {
          resolve({ status, data })
        })
      } catch (err) {
        console.log(err)
        return new Promise((resolve, reject) => {
          resolve({ status })
        })
      }
    },
    async RESET_FORGOTTEN_PASSWORD({ commit }, { token, password }) {
      let status = false
      try {
        const { data } = await apiClient.put('/account/reset-password', { token, password })
        status = true
        return new Promise((resolve, reject) => {
          resolve({ status, data })
        })
      } catch (err) {
        console.log(err)
        return new Promise((resolve, reject) => {
          resolve({ status })
        })
      }
    },
    async VERIFY_EMAIL_REQUEST({ commit }) {
      let status = false
      try {
        const { data } = await apiClient.post('user/request/verification')
        status = true
        return new Promise((resolve, reject) => {
          resolve({ status, data })
        })
      } catch (err) {
        console.log(err)
        return new Promise((resolve, reject) => {
          resolve({ status })
        })
      }
    },
    async VERIFYING_EMAIL({ commit }, { token }) {
      // console.log('VERIFYING_EMAIL token', token)
      let status = false
      try {
        const { data } = await apiClient.put('account/success-verify', { token })
        status = true
        return new Promise((resolve, reject) => {
          resolve({ status, data })
        })
      } catch (err) {
        console.log(err)
        return new Promise((resolve, reject) => {
          resolve({ status })
        })
      }
    },
    async GOOGLE_VALIDATION(_, { googleIdToken }) {
      try {
        const { data: { data } } = await apiClient.get('/account/google-validation', {
          params: {
            googleIdToken,
          },
        })
        return new Promise((resolve, reject) => {
          resolve(data)
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
  },
  modules: {},
  getters: {
    // userDetail() {
    //   return Vue.$cookies.get('user')
    // },
  },
}
